/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/app/Store';
import { backendApi } from '@/features/apiSlice';
import { conferencerApi } from '@/features/conferencerApi';
import { clearCurrentProject } from '@/features/projectsSlice';
import { reportsApi } from '@/features/reportsApi';

export function Logout() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [logoutUserTrigger, logoutUserQuery] = backendApi.useLogoutUserMutation();

  useEffect(() => {
    if (logoutUserQuery.isLoading) return;
    logoutUserTrigger()
      .unwrap()
      .then(() => {
        dispatch(backendApi.util.resetApiState());
        dispatch(reportsApi.util.resetApiState());
        dispatch(conferencerApi.util.resetApiState());
        dispatch(clearCurrentProject());
        localStorage.clear();
        void navigate('/login');
      })
      .catch((error) => {
        console.error('Logout error:', error);
      });
  }, [logoutUserQuery.isLoading, logoutUserTrigger, dispatch, navigate]);

  return null;
}
